/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 930
// module chunks = 2